<script lang="ts">
import type { Snippet } from 'svelte';
import { fly } from 'svelte/transition';

import { IconButton, Tooltip } from '@viamrobotics/prime-core';

type Callback = () => void;

interface Props {
  open: boolean;
  close: Callback;
  body?: Snippet;
}

const { open, close, body }: Props = $props();

const handleKeyDown = (event: KeyboardEvent) => {
  if (!open) return;
  const { key } = event;
  if (key === 'Escape') {
    close();
  }
};
</script>

<div id="ikp-sidebar-chat-target"></div>

<svelte:window on:keydown={handleKeyDown} />

{@render body?.()}
<aside
  class="fixed bottom-0 right-0 top-0 z-[1000] h-full w-fit min-w-[500px] overflow-hidden border-l border-light bg-white shadow-lg"
  class:hidden={!open}
  transition:fly={{ x: 350, duration: 150 }}
>
  <div class="flex h-full flex-col">
    <nav
      class="flex min-h-[40px] items-center justify-between border-b px-2 text-gray-6"
    >
      <div class="flex items-center"></div>
      <Tooltip
        hoverDelayMS={500}
        let:tooltipID
      >
        <IconButton
          label="minimize"
          icon="arrow-collapse-right"
          aria-describedby={tooltipID}
          on:click={close}
        />
        <p slot="description">Minimize</p>
      </Tooltip>
    </nav>
    <div
      id="inkeepasidetarget"
      style="width: 500px; height: calc(100vh - 41px);"
    ></div>
  </div>
</aside>
